import { render, staticRenderFns } from "./SupplierOrdersPortlet.vue?vue&type=template&id=0c9796da&"
import script from "./SupplierOrdersPortlet.vue?vue&type=script&lang=js&"
export * from "./SupplierOrdersPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports